import "../assets/Modal.css";
import { defineComponent as n, openBlock as r, createElementBlock as l, createElementVNode as s, createVNode as a, withModifiers as i, unref as e } from "vue";
import { d as m } from "./debounce.BDLEW31m.js";
import { _ as c } from "./XClose.vue_vue_type_style_index_0_lang.B6lW8SK8.js";
import { t as d } from "./useModal.CgbJKM9V.js";
const _ = { class: "thn--tool-terms__modal" }, p = ["innerHTML"], T = /* @__PURE__ */ n({
  __name: "Modal",
  props: {
    termsText: {}
  },
  setup(f) {
    const o = m(d, 200, { leading: !0, trailing: !1 });
    return (t, u) => (r(), l("div", _, [
      s("div", {
        class: "thn--tool-terms__modal-text",
        innerHTML: t.termsText
      }, null, 8, p),
      a(c, {
        "only-close-modal": !0,
        onMousedown: i(e(o), ["left"]),
        onClick: e(o)
      }, null, 8, ["onMousedown", "onClick"])
    ]));
  }
});
export {
  T as _
};
//# sourceMappingURL=Modal.vue_vue_type_style_index_0_lang.CjTfpaRL.js.map
